<script setup lang="ts">
const props = defineProps({
  size: null,
  loaderClass: null
})

const containerClass = computed(() => {
  return {
    'h-12 overflow-hidden scale-50 origin-center': props.size === 'sm',
    '': props.size === 'md',
    'scale-80': props.size === 'md-80',
    'scale-60': props.size === 'md-60'
  }
})

const innerClass = computed(() => {
  const res = {
    '!mt-5': props.size === 'sm',
    '': props.size === 'md'
  }
  if (props.loaderClass) {
    Object.assign(res, {
      [props.loaderClass]: true
    })
  }
  return res
})
</script>

<template>
  <div class="w-full" :class="containerClass">
    <div class="loader" :class="innerClass" />
  </div>
</template>

<style scoped lang="less">
.dark {
  .loader {
    font-size: 6px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: mulShdSpin 1.1s infinite ease;
    transform: translateZ(0);
    margin: 20px auto;
  }

  @keyframes mulShdSpin {
    0%,
    100% {
      box-shadow:
        0em -2.6em 0em 0em #ffffff,
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.5),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7);
    }

    12.5% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.7),
        1.8em -1.8em 0 0em #ffffff,
        2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5);
    }

    25% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.5),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7),
        2.5em 0em 0 0em #ffffff,
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
    }

    37.5% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.7),
        1.75em 1.75em 0 0em #ffffff,
        0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
    }

    50% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.5),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.7),
        0em 2.5em 0 0em #ffffff,
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
    }

    62.5% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.5),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.7),
        -1.8em 1.8em 0 0em #ffffff,
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
    }

    75% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.5),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.7),
        -2.6em 0em 0 0em #ffffff,
        -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
    }

    87.5% {
      box-shadow:
        0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
        1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
        2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
        1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
        0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
        -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.5),
        -2.6em 0em 0 0em rgba(255, 255, 255, 0.7),
        -1.8em -1.8em 0 0em #ffffff;
    }
  }
}

// 白色主题
.loader {
  font-size: 8px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin1 1.1s infinite ease;
  transform: translateZ(0);
  margin: 20px auto;
}

@keyframes mulShdSpin1 {
  0%,
  100% {
    box-shadow:
      0em -2.6em 0em 0em #161618,
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.2),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.2),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.2),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.5),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.7);
  }

  12.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.7),
      1.8em -1.8em 0 0em #161618,
      2.5em 0em 0 0em rgba(22, 22, 24, 0.2),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.2),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.2),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.5);
  }

  25% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.5),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.7),
      2.5em 0em 0 0em #161618,
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.2),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.2),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2);
  }

  37.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.2),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.5),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.7),
      1.75em 1.75em 0 0em #161618,
      0em 2.5em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.2),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2);
  }

  50% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.2),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.5),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.7),
      0em 2.5em 0 0em #161618,
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.2),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2);
  }

  62.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.2),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.2),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.5),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.7),
      -1.8em 1.8em 0 0em #161618,
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2);
  }

  75% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.2),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.2),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.2),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.5),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.7),
      -2.6em 0em 0 0em #161618,
      -1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2);
  }

  87.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(22, 22, 24, 0.2),
      1.8em -1.8em 0 0em rgba(22, 22, 24, 0.2),
      2.5em 0em 0 0em rgba(22, 22, 24, 0.2),
      1.75em 1.75em 0 0em rgba(22, 22, 24, 0.2),
      0em 2.5em 0 0em rgba(22, 22, 24, 0.2),
      -1.8em 1.8em 0 0em rgba(22, 22, 24, 0.5),
      -2.6em 0em 0 0em rgba(22, 22, 24, 0.7),
      -1.8em -1.8em 0 0em #161618;
  }
}
</style>
